export const groups = [
    "relatives.self",
    "relatives.great",
    "relatives.grand",
    "relatives.parent",
    "relatives.sibling",
    "relatives.child",
    "relatives.grandChild",
    "relatives.halfSibling",
    "relatives.firstCousin",
    "relatives.auntOrUncle",
    "relatives.nieceOrNephew",
    "relatives.greatAuntOrUncle",
];
export const subGroups = [
    "relatives.greatGrandmother.unselected",
    "relatives.greatGrandfather.unselected",
    "relatives.grandmother.unselected",
    "relatives.grandfather.unselected",
    "relatives.greatAunt.unselected",
    "relatives.greatUncle.unselected",
    "relatives.mother",
    "relatives.father",
    "relatives.aunt.unselected",
    "relatives.uncle.unselected",
    "relatives.brother",
    "relatives.sister",
    "relatives.halfSister.unselected",
    "relatives.halfBrother.unselected",
    "relatives.femaleCousin.unselected",
    "relatives.maleCousin.unselected",
    "relatives.son",
    "relatives.daughter",
    "relatives.niece",
    "relatives.nephew",
    "relatives.grandson",
    "relatives.granddaughter",
];
/***********************************************************************************
 * Changes to this list will impact all other lists here,                          *
 * please make sure you have made the relevant updates when adding a relative here *
 ***********************************************************************************/
export const relatives = [
    "relatives.greatGrandmother.maternal",
    "relatives.greatGrandfather.maternal",
    "relatives.greatGrandmother.paternal",
    "relatives.greatGrandfather.paternal",
    "relatives.grandmother.maternal",
    "relatives.grandfather.maternal",
    "relatives.greatAunt.maternal",
    "relatives.greatUncle.maternal",
    "relatives.grandmother.paternal",
    "relatives.grandfather.paternal",
    "relatives.greatAunt.paternal",
    "relatives.greatUncle.paternal",
    "relatives.mother",
    "relatives.father",
    "relatives.aunt.maternal",
    "relatives.uncle.maternal",
    "relatives.aunt.paternal",
    "relatives.uncle.paternal",
    "relatives.brother",
    "relatives.sister",
    "relatives.femaleCousin.maternal",
    "relatives.femaleCousin.paternal",
    "relatives.maleCousin.maternal",
    "relatives.maleCousin.paternal",
    "relatives.son",
    "relatives.daughter",
    "relatives.niece",
    "relatives.nephew",
    "relatives.grandson",
    "relatives.granddaughter",
    "relatives.self",
    "relatives.halfSister.maternal",
    "relatives.halfSister.paternal",
    "relatives.halfBrother.maternal",
    "relatives.halfBrother.paternal",
];
export const femaleRelatives = [
    "relatives.greatGrandmother.maternal",
    "relatives.greatGrandmother.paternal",
    "relatives.grandmother.maternal",
    "relatives.grandmother.paternal",
    "relatives.greatAunt.maternal",
    "relatives.greatAunt.paternal",
    "relatives.aunt.maternal",
    "relatives.aunt.paternal",
    "relatives.mother",
    "relatives.sister",
    "relatives.daughter",
    "relatives.niece",
    "relatives.granddaughter",
    "relatives.halfSister.maternal",
    "relatives.halfSister.paternal",
    "relatives.femaleCousin.maternal",
    "relatives.femaleCousin.paternal",
];
export const maleRelatives = [
    "relatives.greatGrandfather.maternal",
    "relatives.greatGrandfather.paternal",
    "relatives.grandfather.maternal",
    "relatives.grandfather.paternal",
    "relatives.greatUncle.maternal",
    "relatives.greatUncle.paternal",
    "relatives.uncle.maternal",
    "relatives.uncle.paternal",
    "relatives.father",
    "relatives.brother",
    "relatives.son",
    "relatives.nephew",
    "relatives.grandson",
    "relatives.halfBrother.maternal",
    "relatives.halfBrother.paternal",
    "relatives.maleCousin.maternal",
    "relatives.maleCousin.paternal",
];
export const uniqueRelatives = [
    "relatives.grandmother.paternal",
    "relatives.grandmother.maternal",
    "relatives.grandfather.paternal",
    "relatives.grandfather.maternal",
    "relatives.mother",
    "relatives.father",
    "relatives.self",
];
